import { render } from "./DetailTable.vue?vue&type=template&id=260d579e&scoped=true"
import script from "./DetailTable.vue?vue&type=script&lang=js"
export * from "./DetailTable.vue?vue&type=script&lang=js"

import "./DetailTable.vue?vue&type=style&index=0&id=260d579e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-260d579e"]])

export default __exports__